export default {

  login () {
    window.open(`${process.env.VUE_APP_API_BASE_URL}/twitter/login`, '_self')
  },

  openShareDialogue (href, quote) {
    window.open(`https://twitter.com/intent/tweet?text=${quote || ''}&url=${href}`, 'Twitter', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,width=500,height=600,resizable=1')
  }

}
